/** VUEX module for format management **/
import responseNotification from '../lib/responseNotification.js'

import {getFormats, updateFormat, getAllFormats, deleteFormat, updateSortFormats, getSelectedFormats} from '../lib/api/calls';

export default {
  namespaced: true,
  state: {
    formats: [],
    searchFilter: '',
    allFormats: [],
    selectedFormats: []
  },
  getters: {
    formats (state, getters, rootState) {
      let formats = state.formats;
      if (rootState.account && rootState.account.has_selected_formats) {
        formats = state.selectedFormats
      }
      if (state.searchFilter) {
        return formats.filter(item => item.name.toLowerCase().indexOf(state.searchFilter.toLowerCase()) > -1)
      }
      return formats
    },
    unfiltered (state) {
      return state.formats
    },
    allFormats (state) {
      return state.allFormats
    },
    custom (state) {
      if (state.searchFilter) {
        return state.formats.filter(format => format.custom).filter(item => item.name.toLowerCase().indexOf(state.searchFilter.toLowerCase()) > -1)
      }
      return state.formats.filter(format => format.custom)
    }
  },
  mutations: {
    setSearchFilter (state, value) {
      state.searchFilter = value
    },
    setFormats (state, formats) {
      state.formats = formats
    },
    setAllFormats (state, formats) {
      state.allFormats = formats
    },
    setSelectedFormats (state, formats) {
      state.selectedFormats = formats
    },
    updateSort (state, formats) {
      if (state.formats.length != formats.length) {
        responseNotification(this, {error: 'Must sort original list of ads only! (Clear Search)'});
        return;
      }
      state.formats = formats;
      let format_ids = formats.map(function (obj) {
        return obj.id;
      });
      updateSortFormats(format_ids).then((response) => {
        responseNotification(this, {}, 'Successfully Updated Order!');
      });
    }
  },
  actions: {
    load ({commit}) {
      return getFormats().then(formats => {
        commit('setFormats', formats)
        return formats
      })
    },
    loadAll ({commit}) {
      return getAllFormats().then(formats => commit('setAllFormats', formats))
    },
    loadSelected ({commit}) {
      return getSelectedFormats().then(formats => commit('setSelectedFormats', formats))
    },
    update (context, {id, payload, callback}) {
      updateFormat(id, payload).then((response) => {
        responseNotification(context, response, 'Format updated!')
        context.dispatch('loadAll')
        if (callback) callback(response)
      })
    },
    delete (context, id) {
      deleteFormat(id).then((response) => {
        responseNotification(context, response, 'Format Deleted!')
        context.dispatch('formats/loadAll', {}, {root: true})
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/formats.js